/**
 * Function to retrieve label from the id
 * @param {Form} form the current form
 * @param {String} fieldId the fieldId corresponding to the desired label
 * @param {String} currentLocale the current locale, defaults to english (en)
 * @returns {String}
 */

export const getLabelFromFormId = (form = { pages: [] }, fieldId, currentLocale = 'en') => {
  const event = findFieldInPages(form.pages, fieldId);
  if (!event) {
    // When field "hasNotes", it generates a field that arrives to PC with no associated event. We try to find its label here.
    const notesField = form.pages.flatMap(page => page.fields).find(field => field.hasNotes && field.hasNotes.id === fieldId)?.hasNotes;
    if (notesField?.label) {
      return notesField.label;
    }
    console.warn('no label found, wrong form passed?', form, fieldId);
    return fieldId;
  }
  if (typeof event.label === 'object') {
    return event.label[currentLocale];
  }
  return event.label;
};

const findFieldInPages = (pages, fieldId) => {
  return pages.reduce((fieldToFind, page) => {
    if (fieldToFind) {
      return fieldToFind;
    }
    return findFieldById(page.fields, fieldId) || fieldToFind;
  }, null);
};

const findFieldById = (fields, fieldId) => {
  // we check if we have the correct field in the fields array
  for (const field of fields) {
    if (field.id === fieldId) {
      return field;
    }
    // if not, but the field has a fields property itself, we call this function recursively
    // and check if we have found the label we are looking for
    if (field.fields) {
      const found = findFieldById(field.fields, fieldId);
      if (found) {
        // Some fields have no label since the Section itself is their label. In this case we want the parent Section
        if (field.component === 'Section' && !found.label) {
          return field;
        }
        return found;
      }
    }
  }
  // if we traverse every fields in the form without finding our desired id, we return null and show the console.warn
  return null;
};
